import './obbligazioni-table-filters.scss';

export class ObbligazioniTableFilters {
  constructor() {
    this.root = document.querySelector('.obbligazioni-table-filters');
    if (!this.root) return;

    this.searchInput = this.root.querySelector('.obbligazioni-table-filters__input--search');
    this.clearSearchBtn = this.root.querySelector('.obbligazioni-table-filters__input-clear');
    this.selectYear = this.root.querySelectorAll('.obbligazioni-table-filters__select');

    this.init();
  }

  init() {
    // Elements required for trigger text updates and mobile controls
    this.mobileApplyBtn = document.getElementById('modalFiltersMobileApplyBtn');
    this.mobileRemoveAllBtn = document.getElementById('modalFiltersMobileRemoveAllBtn');

    this.bindEvents();
    this.setupSearchInput();
  }

  bindEvents() {
    // Apply Button (Mobile)
    if (this.mobileApplyBtn) {
      this.mobileApplyBtn.addEventListener('click', () => {
        this.updateOutput();
      });
    }

    // Remove All Button (Mobile Modal)
    if (this.mobileRemoveAllBtn) {
      this.mobileRemoveAllBtn.addEventListener('click', () => {
        this.clearAll();
      });
    }

    this.selectYear.forEach((sy) => {
      const inputToCheck = sy;
      inputToCheck.addEventListener('change', () => {
        this.updateTrigger();
      });
    });

    this.updateTrigger();
  }

  updateOutput() {
    // deve far azionare categoriesApplyBtn
  }

  setupSearchInput() {
    if (!this.searchInput || !this.clearSearchBtn) return;

    const toggleClearButton = () => {
      if (this.searchInput.value.length > 0) {
        this.clearSearchBtn.classList.add('show');
      } else {
        this.clearSearchBtn.classList.remove('show');
      }
    };

    this.searchInput.addEventListener('input', toggleClearButton);
    this.clearSearchBtn.addEventListener('click', () => {
      this.searchInput.value = '';
      toggleClearButton();
    });

    toggleClearButton();
  }

  updateTrigger() {
    this.selectYear.forEach((sy) => {
      const inputToCheck = sy;
      const hasSelect = inputToCheck && inputToCheck.value && inputToCheck.value.trim() !== '';
      if (hasSelect) {
        inputToCheck.classList.add('has-selection');
      } else {
        inputToCheck.classList.remove('has-selection');
      }
    });
  }

  clearAll() {
    const searchInputs = this.root.querySelectorAll('.obbligazioni-table-filters__input--search');
    searchInputs.forEach((si) => {
      const inputToClear = si;
      inputToClear.value = '';
    });
    const searchClearBtns = this.root.querySelectorAll('.obbligazioni-table-filters__input-clear');
    searchClearBtns.forEach((b) => {
      const clearBtn = b;
      clearBtn.classList.remove('show');
    });
    this.selectYear.forEach((sy) => {
      const inputToClear = sy;
      inputToClear.classList.remove('has-selection');
      inputToClear.value = '';
    });
  }
}
